"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));
var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/inherits"));
var _createSuper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createSuper"));
var _react = _interopRequireDefault(require("react"));
require("./TaskVoiceBuilder.css");
var _VoiceEditor = _interopRequireDefault(require("./VoiceEditor"));
var _CompletedContext = require("../CompletedContext");
var _AlertFeedback = _interopRequireDefault(require("../AlertFeedback/AlertFeedback"));
var _ModalFeedback = _interopRequireDefault(require("../ModalFeedback/ModalFeedback"));
var nop = function nop() {};
var DEBUG = false;
var splitNotation = console.error;
var TaskVoiceBuilder = /*#__PURE__*/function (_React$Component) {
  (0, _inherits2.default)(TaskVoiceBuilder, _React$Component);
  var _super = (0, _createSuper2.default)(TaskVoiceBuilder);
  function TaskVoiceBuilder(props) {
    var _this;
    (0, _classCallCheck2.default)(this, TaskVoiceBuilder);
    _this = _super.call(this, props);
    _this.state = props.state || {};
    if (!_this.state.initialized) {
      _this.state.initialized = true;
      // Initial state is set here, since the constructor can be called more than once.
      _this.state.completed = false;
      _this.state.showAnswer = false;
      _this.state.notation = _this.props.notation || _this.props.musicInitial || _this.props.notation_initial || "zzzzzzzz";
      _this.state.musicInitial = _this.props.musicInitial;
      if (_this.state.musicInitial === "[]" || _this.state.musicInitial === "") _this.state.musicInitial = 'z';
      _this.state.notation = _this.generateNotation(_this.state.musicInitial);
    }
    _this.state.voiceButtons = [_this.props.musicButtonSoprano, _this.props.musicButtonAlto, _this.props.musicButtonTenor, _this.props.musicButtonBass];
    _this.state.startingVoice = ["S", "A", "T", "B"][_this.state.voiceButtons.findIndex(function (a) {
      return a;
    })];
    _this.state.precursor = _this.props.musicConfiguration.split(';').join('\n') + '\n';
    _this.state.correctAnswer = _this.props.correct || _this.props.answers.find(function (a) {
      return a.correct;
    }).answer;
    _this.submit = _this.submit.bind((0, _assertThisInitialized2.default)(_this));
    _this.generateNotation = _this.generateNotation.bind((0, _assertThisInitialized2.default)(_this));
    _this.musiceditor = /*#__PURE__*/_react.default.createRef();
    _this.voiceButtons = [];
    _this.onChange = _this.onChange.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(TaskVoiceBuilder, [{
    key: "generateNotation",
    value: function generateNotation(notation) {
      var voices = notation.split(';');
      notation = "V:S treble up\n" + voices[0] + "\n" + "V:A treble down\n" + voices[1] + "\n" + "V:T bass up\n" + voices[2] + "\n" + "V:B bass down\n" + voices[3];
      if (this.props.musicAnnotation) {
        notation += "\nV:N bass\n" + this.props.musicAnnotation;
      }
      return notation;
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      // Notify the parent of our completion status
      this.context.registerTask(function (id) {
        _this2.setState({
          taskId: id
        });
      });
      this.context.onCompleted(this.state.completed, this.state.taskId);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevprops, prevstate, snapshot) {
      if (prevstate.completed !== this.state.completed || prevstate.taskId !== this.state.taskId) {
        // Make sure our parent knows about the completion
        this.context.onCompleted(this.state.completed, this.state.taskId);
      }
      for (var _i = 0, _Object$keys = Object.keys(this.state); _i < _Object$keys.length; _i++) {
        var key = _Object$keys[_i];
        // Keep our stored state synchronized
        if (this.state[key] !== this.props.state[key]) {
          this.props.state[key] = this.state[key];
        }
      }
      this.state.voiceButtons = [this.props.musicButtonSoprano, this.props.musicButtonAlto, this.props.musicButtonTenor, this.props.musicButtonBass];
      this.state.startingVoice = ["S", "A", "T", "B"][this.state.voiceButtons.findIndex(function (a) {
        return a;
      })];
      this.state.precursor = this.props.musicConfiguration.split(';').join('\n') + '\n';
      this.state.correctAnswer = this.props.correct || this.props.answers.find(function (a) {
        return a.correct;
      }).answer;
      if (prevprops.musicInitial !== this.props.musicInitial) {
        this.state.notation = this.props.notation || this.props.musicInitial || this.props.notation_initial || "zzzzzzzz";
        this.state.musicInitial = this.props.musicInitial;
        if (this.state.musicInitial === "[]" || this.state.musicInitial === "") this.state.musicInitial = 'z';
        this.state.notation = this.generateNotation(this.state.musicInitial);
      }
      if (prevprops.musicAnnotation !== this.props.musicAnnotation) {
        this.state.musicAnnotation = this.props.musicAnnotation;
      }
    }
  }, {
    key: "isTask",
    value: function isTask() {
      return true;
    }
  }, {
    key: "submit",
    value: function submit() {
      var notationSplit = this.state.notation.split('\n');
      var userNotes = [notationSplit[1], notationSplit[3], notationSplit[5], notationSplit[7]];
      var userInput = userNotes.join(";");
      if (this.props.answers) {
        var found = false;
        var _iterator = (0, _createForOfIteratorHelper2.default)(this.props.answers),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var answer = _step.value;
            if (userInput === answer.answer) {
              found = true;
              this.setState({
                completed: answer.correct,
                showAnswer: this.state.correct !== undefined,
                correct: answer.correct,
                showFeedback: !answer.correct,
                showModal: !answer.correct,
                showNag: this.state.showAnswer,
                feedback: answer.feedback
              });
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        if (!found) {
          this.setState({
            completed: false,
            showAnswer: this.state.correct !== undefined,
            correct: false,
            feedback: this.props.feedbackIncorrect,
            showFeedback: true,
            showModal: true,
            showNag: this.state.showAnswer
          });
        }
      } else {
        if (userInput === this.state.correctAnswer) {
          this.setState({
            showAnswer: this.state.correct !== undefined,
            correct: true,
            completed: true,
            notation: this.state.notation,
            showFeedback: false,
            feedback: this.props.feedbackCorrect
          });
        } else {
          this.setState({
            showAnswer: this.state.correct !== undefined,
            correct: false,
            completed: false,
            showFeedback: true,
            showModal: true,
            showNag: this.state.showAnswer,
            feedback: this.props.feedbackIncorrect
          });
        }
      }
    }
  }, {
    key: "onChange",
    value: function onChange(newNotation) {
      this.setState({
        notation: newNotation
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      if (!this.state.error) {
        var _this$props$zoom, _this$props$zoom2;
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "task task-voice-builder",
          style: (0, _objectSpread2.default)({
            width: this.props.musicStaffWidth || "100%",
            display: "inline-block"
          }, this.props.style)
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "voice-builder-container"
        }, /*#__PURE__*/_react.default.createElement(_VoiceEditor.default, Object.assign({
          ref: this.musiceditor
        }, this.props, this.state, {
          addClasses: true,
          addHotspots: true,
          monophonic: true,
          musicButtonAccidentals: true,
          zoom: (_this$props$zoom = this.props.zoom) !== null && _this$props$zoom !== void 0 ? _this$props$zoom : 2,
          millisecondsPerMeasure: this.props.musicDuration || 1000,
          precursor: this.state.precursor,
          notation: this.state.notation,
          answer: this.state.answer,
          correct: this.state.correct,
          reset: this.state.reset,
          round: this.state.submission_number,
          submission_number: this.state.submission_number,
          onChange: this.onChange
        })), /*#__PURE__*/_react.default.createElement("div", {
          style: {
            display: 'inline-block',
            width: '100%'
          }
        }, /*#__PURE__*/_react.default.createElement("button", {
          className: "action-button",
          disabled: this.state.correct,
          style: {
            float: 'left',
            marginLeft: "10px"
          },
          onClick: function onClick() {
            _this3.setState({
              notation: _this3.generateNotation(),
              reset: true
            });
            _this3.musiceditor.current.setState({
              accidental: "",
              voice: _this3.state.startingVoice
            });
          }
        }, "Reset"), /*#__PURE__*/_react.default.createElement("button", {
          className: "action-button",
          disabled: this.state.correct,
          onClick: this.submit,
          style: {
            float: 'right',
            marginRight: "10px"
          }
        }, "Submit")), this.state.showAnswer && !this.state.completed && /*#__PURE__*/_react.default.createElement("div", {
          className: "scale-builder-container",
          style: {
            width: '100%'
          }
        }, /*#__PURE__*/_react.default.createElement("p", {
          style: {
            margin: "10px 0px",
            padding: "10px",
            backgroundColor: "#d4edda",
            borderRadius: "5px",
            border: "1px c3e6cb solid"
          }
        }, "The correct answer is shown below. Update your answer to match it to move on."), /*#__PURE__*/_react.default.createElement(_VoiceEditor.default, Object.assign({}, this.props, this.state, {
          musicButtonSATB: false,
          musicButtonAccidentals: false,
          addClasses: true,
          addHotspots: true,
          monophonic: true,
          accidentals: true,
          zoom: (_this$props$zoom2 = this.props.zoom) !== null && _this$props$zoom2 !== void 0 ? _this$props$zoom2 : 2,
          millisecondsPerMeasure: this.props.musicDuration || 1000,
          precursor: this.state.precursor,
          notation: this.generateNotation(this.state.correctAnswer),
          answer: this.state.answer,
          correct: this.state.correct,
          reset: this.state.reset,
          round: this.state.submission_number,
          submission_number: this.state.submission_number,
          onChange: nop
        })))), /*#__PURE__*/_react.default.createElement(_ModalFeedback.default, {
          show: this.state.showModal,
          onHide: function onHide() {
            _this3.setState({
              showModal: false
            });
          }
        }, this.state.feedback), (this.state.correct || this.state.showNag) && /*#__PURE__*/_react.default.createElement(_AlertFeedback.default, {
          incorrect: !this.state.correct,
          feedback: this.state.correct ? this.state.feedback : "Input the correct answer to move on."
        }));
      } else {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: "task task-voice-builder voice-builder-container",
          style: {
            width: this.props.musicStaffWidth || "100%",
            display: "inline-block"
          }
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "error-message"
        }, " Oops something went wrong. Please press the \"Question Help/Challenge\" button to bypass this question"));
      }
    }
  }, {
    key: "removeIncorrectNotes",
    value: function removeIncorrectNotes(answer) {
      var _this4 = this;
      var voiceNotes = answer.split(';').map(function (voice, index) {
        if (_this4.state.voiceButtons[index] === 'true') {
          return splitNotation(voice, true);
        } else {
          return [voice];
        }
      });
      var notationSplit = this.state.notation.split('\n');
      // OPTIMIZE: dont serialize unnecesarily
      var userNotes = [notationSplit[1], notationSplit[3], notationSplit[5], notationSplit[7]].map(function (voice, index) {
        // let userNotes = [notationSplit[1], notationSplit[7]].map((voice, index)=>{
        if (_this4.state.voiceButtons[index] === 'true') {
          return splitNotation(voice, true);
        } else {
          return [voice];
        }
      });
      for (var i = 0; i < voiceNotes.length; i++) {
        if (this.state.voiceButtons[i] === 'true') {
          for (var j = 0; j < voiceNotes[i].length; j++) {
            if (voiceNotes[i][j].replace(/\s/g, "") !== userNotes[i][j].replace(/\s/g, "")) userNotes[i][j] = userNotes[i][j].replace(/[A-Z]'*,*/g, 'z').replace(/\^/g, '').replace(/_/g, '').replace(/#/g, '');
          }
        }
      }
      DEBUG && console.log(userNotes);
      var newNotation = "V:S treble up\n" + userNotes[0].join('') + "\n" + "V:A treble down\n" + userNotes[1].join('') + "\n" + "V:T bass up\n" + userNotes[2].join('') + "\n" + "V:B bass down\n" + userNotes[3].join('');
      if (this.props.musicAnnotation) {
        newNotation += "\nV:N bass\n" + this.props.musicAnnotation;
      }
      this.setState({
        notation: newNotation
      });
    }
  }]);
  return TaskVoiceBuilder;
}(_react.default.Component);
TaskVoiceBuilder.contextType = _CompletedContext.CompletedContext;
var _default = exports.default = TaskVoiceBuilder;